import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { GroupDataTable } from '../../components/data-table/group-data-table';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import SplitButtonDropdowns from 'components/split-button-dropdowns';
import {AppSettings} from '../../constants';
import * as RegionMarketActionType from '../constants';
import * as CommonActionType from '../../Common/constants';
import { AddEditRegion } from './add-edit-region';
import { AddEditMarket } from './add-edit-market';
import '../manage-region-market.scss';
import auth from 'Auth/authenticator';
import Translate from '../../components/translate';
import ConfigPOAttachments from './config-po-attachments';

class ManageRegionMarket extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    ManageRegionMarket: PropTypes.object,
    ManageProblem: PropTypes.object,
    RegionProfile: PropTypes.object,
    onSubmit: PropTypes.func,
    item: PropTypes.object,
    MarketProfile: PropTypes.object,
    IsCreate: PropTypes.bool,
    isOpenFormAddEditMarket: PropTypes.bool,
    isOpenFormAddEditRegion: PropTypes.bool,
    ErrorMsg: PropTypes.array,
    SelectListRegions: PropTypes.array,
    Title: PropTypes.string
  }

  static contextTypes = {
    t: PropTypes.func
  }

  constructor(props) {
    super(props);

    let name = '';
    switch (AppSettings.REGION_AND_MARKET) {
      case 1:
        name = 'Regions';
        break;
      case 2:
        name = 'Regions and markets';
        break;
      default:
        menu = null;
        break;
    }
    this.state = {
      roleName: null,
      name: name,
      isOpenFormAddEditRegion: false,
      isOpenFormAddEditMarket: false,
      isOpenModalPurchaseOrderAttachments: false,
      region: null
    };
  }

  componentDidMount() {
    this.binding({
      ...this.objToParams(this.props.ManageRegionMarket.params)
    });
  }

  componentWillReceiveProps(nextProps) {
    const {isOpenFormAddEditRegion, isOpenFormAddEditMarket} = nextProps;
    if (isOpenFormAddEditRegion !== this.state.isOpenFormAddEditRegion) {
      this.setState({isOpenFormAddEditRegion});
    }
    if (isOpenFormAddEditMarket !== this.state.isOpenFormAddEditMarket) {
      this.setState({isOpenFormAddEditMarket});
    }

    if (!this.state.roleName) {
      const roleName = auth.getRoleName();
      this.setState({
        roleName
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RegionMarketActionType.RESET_REGION_MARKET,
      params: null
    });
  }

  renderDescription(item) {
    if (item.description !== '') {
      return <div className='tooltip1'>
        <span className='txt'>{item.description}</span>
        {/*<div className='tooltip-wrapper'>
          <span className='tooltiptext tooltip-bottom'>{item.description}</span>
        </div>*/}
      </div>;
    } else {
      return <span>{item.description}</span>;
    }

  }

  renderName(item) {
    if (item.name !== '') {
      return <div className='tooltip1' style={{paddingLeft: 60}}>
        <span className='txt'>{item.name}</span>
        {/*<div className='tooltip-wrapper'>
          <span className='tooltiptext tooltip-bottom'>{item.name}</span>
        </div>*/}
      </div>;
    } else {
      return <span>{item.name}</span>;
    }

  }

  renderProject(item) {
    return <Link to={`/projects/edit/${item.id}`}>{item.numberOfProjects}</Link>;
  }

  binding(params) {
    this.props.dispatch({
      type: RegionMarketActionType.SEARCH_REGION_ASYNC,
      params: params
    });
  }

  onRegionContextMenu(e, item) {
    var contextItem = contextItem = [
      {
        title: <span>Edit <Translate translateKey='region' /></span>,
        icon: 'glyphicon glyphicon-pencil',
        event: (e1, item1) => {
          this.onOpenAddEditPopup(e1, item1, true);
        }
      },
      {
        title: 'Purchase order attachments',
        icon: 'glyphicon glyphicon-pencil',
        event: (e1, item1) => {
          this.onUpdatePurchaseOrderAttachments(e1, item1);
        }
      }
    ];
    this.cxtMenu.state.event(e, item, contextItem);
  }

  onUpdatePurchaseOrderAttachments = (e, item) => {
    this.setState({
      region: item,
      isOpenModalPurchaseOrderAttachments: true
    });
  }

  onMarketContextMenu(e, item) {
    var contextItem = contextItem = [
      {
        title: <span>Edit <Translate translateKey='market' /></span>,
        icon: 'glyphicon glyphicon-pencil',
        event: (e1, item1) => {
          this.onOpenAddEditPopup(e1, item1, false);
        }
      }
    ];
    this.cxtMenu.state.event(e, item, contextItem);
  }

  onTableBinding = (configTable) => {
    // var params = this.objToParams(this.props.ManageProblem.params);
    // params.itemRepairId = this.props.match.params.itemId.replace('&', '');

    this.binding({
      // ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onGroupTable() {
    // console.log(item);
  }

  onSearch() {
    var params = this.objToParams(this.props.ManageProblem.params);

    $('.s1-ckb').map((i, ckb) => { $(ckb).prop('checked', true); });

    this.binding({
      ...params,
      status: 'all',
      skip: 0
    });
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onSaveRegionMarket = (e, data, regionMarketActionType) => {

    var params = {
      ...this.objToParams(this.props.ManageRegionMarket.params)
    };

    this.props.dispatch({
      type: regionMarketActionType,
      params: {
        data: data,
        search: params
      }
    });
  }

  onOpenAddEditPopup(e, item, isRegion) {
    if (item) {
      this.processEditRegionMarket(item, isRegion);
    } else {
      this.processAddRegionMarket(item, isRegion);
    }
  }

  processAddRegionMarket(item, isRegion) {
    if (isRegion) {
      this.props.dispatch({
        type: RegionMarketActionType.OPEN_FORM_CREATE_REGION,
        params: null
      });
    } else {
      this.props.dispatch({
        type: CommonActionType.COMMON_SELECT_LIST_REGION_ASYNC,
        params: {
          param: { searchKey: '', selectedValue: '' },
          nextAction: [
            { action: RegionMarketActionType.OPEN_FORM_CREATE_MARKET, params: null },
            { action: CommonActionType.COMMON_SELECT_LIST_REGION_SUCCESS, params: null }
          ]
        }
      });
    }
  }

  processEditRegionMarket(item, isRegion) {
    if (isRegion) {
      this.props.dispatch({
        type: RegionMarketActionType.GET_REGION_BY_ID_ASYNC,
        params: item.id
      });

    } else {
      this.props.dispatch({
        type: CommonActionType.COMMON_SELECT_LIST_REGION_ASYNC,
        params: {
          param: { searchKey: '', selectedValue: item.regionId },
          nextAction: [
            { action: RegionMarketActionType.GET_MARKET_BY_ID_ASYNC, params: item.id },
            { action: CommonActionType.COMMON_SELECT_LIST_REGION_SUCCESS, params: null }
          ]
        }
      });
    }
  }

  objToParams(obj) {
    return {
      searchKey: '',
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  resetState = () => {
    this.props.dispatch({
      type: RegionMarketActionType.RESET_REGION_MARKET,
      params: {}
    });

  }

  renderButtonNew() {
    let item = [
      // {label: <Translate translateKey='region' capitalize />, onClick: (e) => { this.onOpenAddEditPopup(e, null, true); }}
    ];
    if (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION_AND_MARKET) {
      item.push({label: <Translate translateKey='market' capitalize />, onClick: (e) => { this.onOpenAddEditPopup(e, null, false); }});
    } else {
      return <button className='btn btn-primary btn-info btn-siteone pull-right btn-icon' onClick={(e) => { this.onOpenAddEditPopup(e, null, true); }}><span className='fa fa-plus icon' />NEW</button>;
    }

    return <div className='dropdown pull-right'>
      <SplitButtonDropdowns
        label={<span><span className='fa fa-plus icon' /> NEW</span>}
        onClick={(e) => { this.onOpenAddEditPopup(e, null, true); }}
        menuItems={item}
      />
    </div>;
  }

  renderTable() {
    const columns = [
      { title: 'Name', name: 'name', sort: true, defaultSortOrder: 'ascending', onGroupTable: this.onGroupTable.bind(this), className: 'titleCol'},
      { title: 'Description', name: 'description', className: 'descCol', headerAlign: 'left', customRender: this.renderDescription.bind(this) },
      { title: <Translate translateKey='project' plurals capitalize />, name: 'numberOfProjects',className: 'countCol' }
      // { title: 'LOTS', name: 'countLots' },
      // { title: 'SOLD', name: 'countSolds' },
      // { title: 'ITEMS', name: 'countItems' },
      // { title: 'OPEN', name: 'countOpens' },
      // { title: 'OVERDUE', name: 'countOverdues' }
    ];
    const groupColumns = [
      { name: 'name', className: 'titleCol', customRender: this.renderName.bind(this) },
      { name: 'description', className: 'descCol', headerAlign: 'left', style: {paddingLeft: 14}, customRender: this.renderDescription.bind(this) },
      { name: 'numberOfProjects', className: 'countCol', headerAlign: 'left', style: {paddingLeft: 14} }
      // { name: 'countLots', className: 'lotsCol' },
      // { name: 'countSolds', className: 'soldCol' },
      // { name: 'countItems', className: 'countItemCol' },
      // { name: 'countOpens', className: 'countOpenCol' },
      // { name: 'countOverdues', className: 'countOverdueCol' }
    ];
    if (this.state.roleName !== AppSettings.BUILDER_USER) {
      columns.push({
        title: '',
        name: 'action',
        className: 'cls-colm-action',
        icon: 'glyphicon glyphicon-option-vertical cls-table-black-icon',
        headerAlign: 'right',
        event: this.onRegionContextMenu.bind(this)
      });
      groupColumns.push({
        title: '',
        name: 'action',
        className: 'cls-colm-action',
        icon: 'glyphicon glyphicon-option-vertical cls-table-black-icon',
        headerAlign: 'right',
        event: this.onMarketContextMenu.bind(this)
      });
    }
    return <GroupDataTable
      groupColumns={groupColumns}
      columns={columns}
      items={this.props.ManageRegionMarket.items}
      configTable={this.props.ManageRegionMarket.params}
      onTableBinding={this.onTableBinding} />;
  }

  renderTitle = () => {
    switch (AppSettings.REGION_AND_MARKET) {
      case 1:
        return <Translate plurals translateKey='region' capitalize />;
      case 2:
        return <span><Translate plurals translateKey='region' capitalize /> and <Translate plurals translateKey='market' /></span>;
      default:
        return '';
    }
  }

  render() {
    return <div id='manage-regions-markets'>
      <div className='page-title clearfix'>
        <h2 className='pull-left'>{this.renderTitle()}</h2>
        {this.state.roleName !== AppSettings.BUILDER_USER && this.renderButtonNew()}
      </div>
      <AddEditRegion item={this.props.RegionProfile}
        errorMsg={this.props.ErrorMsg}
        isOpenFormAddEdit={this.props.isOpenFormAddEditRegion}
        isCreate={this.props.IsCreate}
        title={this.props.Title}
        onCloseModal={this.resetState}
        onSubmit={this.onSaveRegionMarket.bind(this)} />
      <AddEditMarket item={this.props.MarketProfile}
        errorMsg={this.props.ErrorMsg}
        isOpenFormAddEdit={this.props.isOpenFormAddEditMarket}
        isCreate={this.props.IsCreate}
        title={this.props.Title}
        selectListRegions={this.props.SelectListRegions}
        onCloseModal={this.resetState}
        onSubmit={this.onSaveRegionMarket.bind(this)} />
      {this.renderTable()}
      {this.state.isOpenModalPurchaseOrderAttachments &&
        <ConfigPOAttachments
          show={this.state.isOpenModalPurchaseOrderAttachments}
          region={this.state.region}
          onCloseModal={() => {this.setState({ isOpenModalPurchaseOrderAttachments: false });}}
        />
      }
      <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
      <MessengerBox ref={(ref) => { this.msgBox = ref; }} title={AppSettings.COMPANY_NAME} />
    </div>;
  }
}

const mapStateToProps = (state) => {
  return state.RegionMarketStore;
};

export default connect(mapStateToProps)(ManageRegionMarket);



// WEBPACK FOOTER //
// ./src/Region-Market/Containers/manage-region-market.js